export default __webpack_public_path__ + "static/media/DSCN6141_1 (1).ae409e75.jpg";